module.exports = __webpack_public_path__ + "static/media/plan.c90028f4.svg";